import Vue from 'vue';

import { apiPath } from '@/api/constants';

export default Vue.resource(
  `${apiPath}/adbazaar{/v}{/type}{/itemId}{/action}{/subAction}`,
  {},
  {
    editBids: {
      method: 'PATCH',
      params: { type: 'campaigns', action: 'bids', v: 'v3' },
    },
    deleteBids: {
      method: 'DELETE',
      params: { type: 'campaigns', action: 'bids', v: 'v3' },
    },
    getBids: {
      method: 'GET',
      params: { type: 'campaigns', action: 'bids', v: 'v3' },
    },
    rejectSuggestion: {
      method: 'POST',
      params: { type: 'suggestions', action: 'reject' },
    },
    getQuerySuggestions: {
      method: 'GET',
      params: { type: 'campaigns', action: 'suggestions' },
    },
    getSearchTerms: {
      method: 'GET',
      params: { type: 'campaigns', action: 'search-terms' },
    },
    getBidsCSV: {
      method: 'GET',
      params: { type: 'campaigns', action: 'bids', v: 'v3', export: 'csv' },
    },
  },
);
